import React, { FC } from "react";
import { Box } from "@mui/material";

import { BRSR_CONFIG } from "../config";

import { PbiReport } from "@components/common";

const BrsrDashboardPage: FC = () => (
  <Box>
    <PbiReport
      pageId={BRSR_CONFIG.overview.reportPageId}
      height={600}
      bg="default"
    />
  </Box>
);

export default BrsrDashboardPage;
